'use client'
import {useState,useEffect} from 'react'
import SocialButton from "@/app/Components/Element_Components/socialButton/SocialButton";
import {
  FaFacebookF,
  FaWhatsapp,
  FaLinkedin,
  FaInstagram,
  FaYoutube,
  FaFlickr,
  FaTelegram,
} from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { collectionLoader } from '@/utils/fetchCollection';
import { getPublicBaseUrl } from '@/lib/getBaseURL';
type SocialsProps = {
  bgColor?: string;
  size?: string;
  iconSize?: string;
  className?: string;
};

interface Social {
     url:'',
     icon: {
      url:''
     }
}
const Socials = ({ bgColor, size, iconSize, className }: SocialsProps) => {
  const [socialLinks, setSocialLinks] = useState<Social[]>([]);
  useEffect(()=>{
     const fetchSocial = async()=>{
      const links = await collectionLoader<Social>('social-media-links','en')
      setSocialLinks(links)
     }
     fetchSocial()
  },[])
  // Example social media data - you can customize this
  // const socialLinks = [
  //   // {
  //   //   href: "/",
  //   //   icon: <FaXTwitter />,
  //   //   bgColor: "bg-[#004370]",
  //   // },
  //   {
  //     href: "https://web.facebook.com/CCIFDRE",
  //     icon: <FaFacebookF />,
  //     bgColor: "bg-[#004370]",
  //   },
  //   {
  //     href: "https://www.youtube.com/@cci2025",
  //     icon: <FaYoutube />,
  //     bgColor: "bg-[#004370]",
  //   },
  //   {
  //     href: "https://t.me/cci_sec1",
  //     icon: <FaTelegram />,
  //     bgColor: "bg-[#004370]",
  //   },

  //   {
  //     href: "https://linkedin.com/username",
  //     icon: <FaLinkedin />,
  //     bgColor: "bg-[#004370]",
  //   },
  // ];

  return (
    <div className={`flex gap-1 md:gap-4 ${className}`}>
      {socialLinks.map((social, index) => (
        <SocialButton
          key={index}
          href={social.url}
          icon={getPublicBaseUrl()+social.icon.url}
          bgColor={'white'}
          size={'14px'}
          iconSize={'14px'}
        />
      ))}
    </div>
  );
};

export default Socials;
